import { Reveal } from "./Reveal";
import { PHOTOS } from "../images";

export const Celebrations = () => (
  <section data-testid="celebrations-section" className="grain relative overflow-hidden bg-brand-sepia py-24 lg:py-44">
    {PHOTOS.celebration && (
      <>
        <img
          src={PHOTOS.celebration}
          alt="The outdoor lawns of Area 83 set for a celebration"
          data-testid="celebrations-image"
          loading="lazy"
          className="drift-zoom absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-brand-licorice/60" />
      </>
    )}
    <div className="relative z-[2] mx-auto max-w-7xl px-6 sm:px-8">
      <Reveal className="max-w-3xl">
        <p className="mb-5 text-[11px] font-semibold uppercase tracking-[0.28em] text-brand-champagne">
          Celebrations & group stays
        </p>
        <h2 className="font-serif text-4xl font-light leading-[1.1] tracking-tight text-brand-ivory sm:text-5xl lg:text-6xl">
          Bring everyone <span className="italic text-brand-champagne">together.</span>
        </h2>
        <p className="mt-7 max-w-xl text-[15px] leading-relaxed text-brand-ivory/85 sm:text-lg">
          Birthdays, reunions, intimate celebrations or a simple weekend away. A private villa for your group, with
          the lawns and experiences of Area 83 around you.
        </p>
        <a
          href="#enquire"
          data-testid="celebrations-cta"
          className="mt-10 inline-block bg-brand-ivory px-9 py-4 text-[13px] font-semibold uppercase tracking-[0.16em] text-brand-licorice transition-colors hover:bg-brand-champagne"
        >
          Plan a group stay
        </a>
      </Reveal>
    </div>
  </section>
);
